import { BasicController, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";

import { int } from "@goodgamestudios/math-utilities";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { SFConstants } from "../../constants/SFConstants";
import { Poker2BuddyEvent } from "../../event/Poker2BuddyEvent";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { BuddyVO } from "../../gamevo/BuddyVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { Poker2Model } from "../Poker2Model";

export class Poker2BuddyData {

    private static DELIMITER_SET: string = "|||";
    private static DELIMITER_DATA: string = "|";
    private static INGAMEBUDDIES: number = 0;

    private flashVarBuddyData: string = "";

    private _preSocialBuddies: any[];
    private _completeSocialBuddies: any[];
    private _ingameBuddies: any[];
    private _isFriendshipRequested: boolean;

    constructor(flashVarBuddyData: string = null) {
        this.flashVarBuddyData = flashVarBuddyData;
        this._ingameBuddies = [];
        this._preSocialBuddies = [];
        this._completeSocialBuddies = [];
    }

    // flashVarBuddyData: pln|pln|||Thumb|Thumb
    public getSocialBuddyData( /*event:SocialDataEvent*/): void {
        this._preSocialBuddies = [];
        this._completeSocialBuddies = [];

        var ary: any[] = new Array();
        var itemsArray: any[] = new Array();

        if (this.flashVarBuddyData)
            ary = this.flashVarBuddyData.split(Poker2BuddyData.DELIMITER_SET);

        if (!this.flashVarBuddyData || this.flashVarBuddyData == "" || ary[0] == "") {
            BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changebuddydata"));
            return;
        }

        var plnAry: any[] = ary[0].split(Poker2BuddyData.DELIMITER_DATA);

        if (plnAry[0] == "")
            return;
        var buddiesThumbsAry: any[] = ary[1].split(Poker2BuddyData.DELIMITER_DATA);

        for (var i: number = 0; i < plnAry.length; i++) {
            var buddy: BuddyVO = new BuddyVO();
            buddy.pln = String(plnAry[i]);
            buddy.thumbUrl = buddiesThumbsAry[i];

            itemsArray.push(String(plnAry[i]));
            this._preSocialBuddies.push(buddy);
        }

        BasicModel.smartfoxClient.sendMessage("sbs", [ary[0]]);
    }

    /**
     * Daten der Netzwerkfreunde speichern
     */
    public addSocialBuddyAvatarInfo(paramObject: any): void {
        if (!paramObject || paramObject.B.length < 1)
            return;

        for (let entryList of paramObject.B) {
            var info: any = entryList;
            if (info === undefined) continue;

            var pln: string = info[0];

            if (this._preSocialBuddies != null) {
                for (let entryList of this._preSocialBuddies) {
                    var buddy: any = entryList;
                    if (buddy === undefined) continue;

                    if (buddy.pln == pln) {
                        buddy.playerId = int(info[1]);

                        if (this.isIngameBuddyByPlayerId(buddy.playerId))
                            this.removeBuddy(buddy.playerId);
                        buddy.playerName = info[2];
                        buddy.playerXp = info[3];
                        buddy.cashTotal = info[4];
                        buddy.currentTableId = int(info[5]);
                        buddy.isOnline = info[6];
                        buddy.isSocialFriend = true;

                        if (buddy.playerName != "") {
                            buddy.avatarVO = Poker2Model.avatarData.parseAvatar(info[7], info[8], info[9]);
                            this._ingameBuddies.push(buddy);
                            this._completeSocialBuddies.push(buddy);
                        }
                    }
                }
            }
        }
        this._ingameBuddies.sortOn("playerXp", Array.NUMERIC | Array.DESCENDING);
        BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changebuddydata"));
    }

    public addIngameBuddyAvatarInfo(paramObject: any): void {
        this._ingameBuddies = [];

        if (paramObject && paramObject.B.length > 0) {
            for (let entryList of paramObject.B) {
                var buddyData: any = entryList;
                if (buddyData === undefined) continue;
                this.addIngameBuddy(buddyData);
            }

            this._ingameBuddies.sortOn("playerXp", Array.NUMERIC | Array.DESCENDING);
        }
        BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changebuddydata"));
    }

    public getBuddyByPlayerId(playerId: number): BuddyVO {
        /*			for each(var socialBuddy:BuddyVO in socialBuddyList)
                    {
                        if (socialBuddy.playerId == playerId)
                            return socialBuddy;
                    }*/
        if (this.ingameBuddyList != null) {
            for (let entryList of this.ingameBuddyList) {
                var ingameBuddy: any = entryList;
                if (ingameBuddy === undefined) continue;

                if (ingameBuddy.playerId == playerId)
                    return ingameBuddy;
            }
        }
        return null;
    }

    public parse_BOS(paramObject: any): void {
        if (paramObject && paramObject.B.length > 0) {
            for (let entryList of paramObject.B) {
                var buddyData: any = entryList;
                if (buddyData === undefined) continue;
                this.changeOnlineState(buddyData.id, buddyData.isOnline);
            }
        }
        BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changeonlinestate"));
    }

    private changeOnlineState(playerId: number, isOnline: boolean): void {
        var buddyVO: BuddyVO = this.getBuddyByPlayerId(playerId);

        if (buddyVO)
            buddyVO.isOnline = isOnline;
    }

    private isIngameBuddyByPlayerId(playerId: number): boolean {
        if (this.ingameBuddyList != null) {
            for (let entryList of this.ingameBuddyList) {
                var buddy: any = entryList;
                if (buddy === undefined) continue;

                if (buddy.playerId == playerId)
                    return true;
            }
        }
        return false;
    }

    public isSocialBuddyByPlayerId(playerId: number): boolean {
        if (this.socialBuddyList != null) {
            for (let entryList of this.socialBuddyList) {
                var buddy: any = entryList;
                if (buddy === undefined) continue;

                if (buddy.playerId == playerId)
                    return true;
            }
        }
        return false;
    }

    public isBuddyByPlayerId(playerId: number): boolean {
        return (this.isSocialBuddyByPlayerId(playerId) || this.isIngameBuddyByPlayerId(playerId));
    }

    /**
     * BuddyData:
     *  id, name, xp, chips, currentTable, <avatar>
     */
    public addIngameBuddy(buddyData: any): void {
        var buddyVO: BuddyVO = new BuddyVO();
        buddyVO.playerId = int(buddyData.id);
        buddyVO.playerName = buddyData.name;
        buddyVO.playerXp = buddyData.xp;
        buddyVO.cashTotal = buddyData.chips;
        buddyVO.currentTableId = int(buddyData.currentTable);
        buddyVO.isOnline = buddyData.isOnline;
        buddyVO.avatarVO = Poker2Model.avatarData.parseAvatar(buddyData.avatar.gender, buddyData.avatar.allowGiveChips, buddyData.avatar.items);
        this._ingameBuddies.push(buddyVO);
        BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changebuddydata"));
    }

    /**
     * Dispatch AddFriend-Event, for animation on table
     * friendData:
     *  fromIndex, toIndex
     */
    public addOnTableFriend(friendData: any): void {
        var fromIndex: number = int(friendData.fromIndex);
        var toIndex: number = int(friendData.toIndex);
        BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("addfriend", [fromIndex, toIndex]));
    }

    public removeBuddy(buddyPlayerId: number): void {
        for (var i: number = 0; i < this.ingameBuddyList.length; i++) {
            var buddy: BuddyVO = this.ingameBuddyList[i];

            if (buddy.playerId == buddyPlayerId) {
                this.ingameBuddyList.splice(i, 1);
                BasicController.getInstance().dispatchEvent(new Poker2BuddyEvent("changebuddydata"));
                return;
            }
        }
    }

    private get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    public get friendList(): any[] {
        /*			if (env.loginIsKeyBased)
                        return addMyAvatarToList(socialBuddyList);
                    else*/
        return this.addMyAvatarToList(this.ingameBuddyList);
    }

    private isMyAvatarInList(list: any[]): boolean {
        for (var i: number = 0; i < list.length; i++) {
            if ((list[i] as BuddyVO).playerId == Poker2Model.userData.playerID) {
                return true;
            }
        }
        return false;
    }

    private addMyAvatarToList(list: any[]): any[] {

        var result: any[] = [];

        if (!this.isMyAvatarInList(list)) {
            var myBuddyVO: BuddyVO = new BuddyVO();
            myBuddyVO.playerId = int(Poker2Model.userData.playerID);
            myBuddyVO.playerName = Poker2Model.userData.userName;
            myBuddyVO.playerXp = Poker2Model.userData.userXP;
            myBuddyVO.cashTotal = Poker2Model.userData.userCash;
            myBuddyVO.currentTableId = -1;
            myBuddyVO.isOnline = true;
            myBuddyVO.avatarVO = VOHelper.clone(Poker2Model.avatarData.myAvatar) as AvatarVO;
            myBuddyVO.avatarVO.avatarWear = new Map<any, any>();
            myBuddyVO.avatarVO.allowGiveChips = false;

            for (let entryList of Array.from(Poker2Model.avatarData.myAvatar.avatarWear.values())) { var item: any = entryList; myBuddyVO.avatarVO.avatarWear.set(item.id, VOHelper.clone(item) as ItemsVO); }
            result = [myBuddyVO];
        }

        if (list != null) {
            for (let entryList of list) {
                var buddy: any = entryList;
                if (buddy === undefined) continue;
                result.push(buddy);
            }
        }

        result.sortOn("playerXp", Array.NUMERIC | Array.DESCENDING);
        return result;
    }

    public get socialBuddyList(): any[] {
        return this._completeSocialBuddies;
    }

    public get ingameBuddyList(): any[] {
        return this._ingameBuddies;
    }

    public get isFriendshipRequested(): boolean {
        return this._isFriendshipRequested;
    }

    public set isFriendshipRequested(value: boolean) {
        this._isFriendshipRequested = value;
    }
	/*		public function get completeBuddyList():Array
			{
				_completeSocialBuddies.sortOn("playerXp", Array.NUMERIC | Array.DESCENDING);
				_ingameBuddies.sortOn("playerXp", Array.NUMERIC | Array.DESCENDING);
				var allBuddies:Array = _completeSocialBuddies.concat(_ingameBuddies);
				return allBuddies;
			}
			public function get amountSocialFriends():int
			{
				return _completeSocialBuddies.length;
			}
			public function get amountIngameFriends():int
			{
				return _ingameBuddies.length;
			}
			public function get amountAllFriends():int
			{
				return completeBuddyList.length;
			}*/
}
